import { render, staticRenderFns } from "./SegmentType.vue?vue&type=template&id=e5ed30aa"
import script from "./SegmentType.vue?vue&type=script&lang=js"
export * from "./SegmentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports